@if(loading()) {
  <div class="d-flex flex-grow-1 flex-column my-5 align-content-center justify-content-center">
    <p-progress-spinner ariaLabel="loading" />
  </div>
}

<div [class.d-none]="loading()" class="columnify">

  <div
    #parentDiv
    class="table-column"
  >
    <ul #stickyContentsTable class="contents-table sticky">
      <a class="d-inline-flex justify-content-between align-items-start" style="font-weight: bold">{{ translations.title }}</a>

      <li>
        <a [class.active]="activeSection === 'hospital_reports'" (click)="goTo(hospital_reports)">
          {{ translations.hospital_reports }}
        </a>
      </li>

      <li>
        <a [class.active]="activeSection === 'lab_reports'" (click)="goTo(lab_reports)">
          {{ translations.lab_reports }}
        </a>
      </li>

      <li>
        <a [class.active]="activeSection === 'medical_reports'" (click)="goTo(medical_reports)">
          {{ translations.medical_reports }}
        </a>
      </li>

      <li>
        <a [class.active]="activeSection === 'medical_images'" (click)="goTo(medical_images)">
          {{ translations.medical_images }}
        </a>
      </li>
    </ul>
  </div>

  <div class="d-flex flex-column overflow-x-hidden">
    <router-outlet id="buttonsSection"/>

    <div #content_hospital_reports class="flex-row flex-fill border border-1 rounded-3 border-primary p-2 my-2 overflow-x-auto">
      <div
        (window:scroll)="onScroll($event, hospital_reports, content_hospital_reports)"
        (window:scrollend)="onScroll($event, hospital_reports, content_hospital_reports)"
        #hospital_reports
        id="hospital_reports"
        class="hospital-reports-table"
      ></div>

      <ncp-hospital-reports (loaded)="onSectionLoaded('hospital')" />
    </div>

    <div #content_lab_reports class="flex-row flex-fill border border-1 rounded-3 border-primary p-2 my-2 overflow-x-auto">
      <div
        (window:scroll)="onScroll($event, lab_reports, content_lab_reports)"
        (window:scrollend)="onScroll($event, lab_reports, content_lab_reports)"
        #lab_reports
        id="lab_reports"
        class="lab-reports-table"
      ></div>

      <ncp-lab-reports (loaded)="onSectionLoaded('lab')" />
    </div>

    <div #content_medical_reports class="flex-row flex-fill border border-1 rounded-3 border-primary p-2 my-2 overflow-x-auto">
      <div
        (window:scroll)="onScroll($event, medical_reports, content_medical_reports)"
        (window:scrollend)="onScroll($event, medical_reports, content_medical_reports)"
        #medical_reports
        id="medical_reports"
        class="medical-reports-table"
      ></div>

      <ncp-medical-reports (loaded)="onSectionLoaded('report')" />
    </div>

    <div #content_medical_images class="flex-row flex-fill border border-1 rounded-3 border-primary p-2 my-2 overflow-x-auto">
      <div
        (window:scroll)="onScroll($event, medical_images, content_medical_images)"
        (window:scrollend)="onScroll($event, medical_images, content_medical_images)"
        #medical_images
        id="medical_images"
        class="medical-images-table"
      ></div>

      <ncp-medical-images (loaded)="onSectionLoaded('image')" />
    </div>

  </div>
</div>
